var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailShare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_362_777)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.8837 9.99998C53.6566 9.97657 53.4276 9.97657 53.2004 9.99998H6.53372C6.23463 10.0046 5.93752 10.0494 5.65039 10.1333L29.7337 34.1166L53.8837 9.99998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3501 12.3167L32.0835 36.4833C31.4589 37.1042 30.6141 37.4526 29.7335 37.4526C28.8528 37.4526 28.008 37.1042 27.3835 36.4833L3.33346 12.5C3.25953 12.7717 3.22033 13.0517 3.2168 13.3333V46.6666C3.2168 47.5507 3.56799 48.3986 4.19311 49.0237C4.81823 49.6488 5.66608 50 6.55013 50H53.2168C54.1008 50 54.9487 49.6488 55.5738 49.0237C56.1989 48.3986 56.5501 47.5507 56.5501 46.6666V13.3333C56.5369 12.9861 56.4694 12.643 56.3501 12.3167ZM8.83346 46.6666H6.5168V44.2833L18.6335 32.2667L20.9835 34.6167L8.83346 46.6666ZM53.1835 46.6666H50.8501L38.7001 34.6167L41.0501 32.2667L53.1668 44.2833L53.1835 46.6666Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_362_777"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailShare);
export default __webpack_public_path__ + "static/media/email-share.2ae6115a241dc5b7be1e10fb44de8411.svg";
export { ForwardRef as ReactComponent };